// src/component/ui/AccountPausedBanner.jsx
// Shown on every tenant page while the landlord's organisation is suspended
// (S1f). Tenants keep READ-ONLY portal access: the backend refuses every
// unsafe request (incl. the pay-rent STK push) with 403 account_suspended,
// so the banner explains what the disabled actions mean.
import React from 'react';
import { PauseCircle } from 'lucide-react';

export default function AccountPausedBanner() {
  return (
    <div className="mb-6 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
         role="status" data-testid="account-paused-banner">
      <PauseCircle size={18} className="mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">Payments paused — contact your landlord</p>
        <p className="text-amber-800/90 text-xs mt-0.5">
          Your landlord's account is temporarily suspended. You can still view your lease, invoices and receipts;
          rent payments, maintenance requests and other changes are paused until it is reinstated.
        </p>
      </div>
    </div>
  );
}
